<template>
    <div style="width: 100%;background: #fff;">
        <div style="width: 1200px; margin: auto;padding-top: 10px;">
            <div style="margin-top: 20px;border-bottom: solid 1px #D5D5D5;padding-bottom: 10px;">
                <img style="vertical-align: sub;" src="@/assets/home/titleTip.png">
                <span style="font-size: 18px;line-height: 25px;font-weight: 600;margin: 0 5px;">{{$t('view.招询公告')}}</span>
                <!-- <span style="font-size: 14px;color: #999999;line-height: 20px;">Inquiry announcement</span> -->
            </div>
            <div class="topList" @click="clickup($event)" id="Announcement">
                <vueSeamlessScroll ref="scroller" :data="listData" :class-option="scrollOptions"  style="overflow: hidden;height: 300px;" >
                    <div :data-obj="JSON.stringify(item)" class="listHover" v-for="(item,index) in listData" :key="index">
                        <div :data-obj="JSON.stringify(item)"  :class="[item.biddingType==1?'mainColor':'textBlue']">[{{ item.biddingType==1?$t('view.询价'):$t('view.招标') }}]</div>
                        <div :data-obj="JSON.stringify(item)"  style="flex:1;margin: 0 20px;" class="single-line" :title="item.sectionName">{{ item.sectionName}}</div>
                        <div :data-obj="JSON.stringify(item)" v-if="item.biddingType==1" :class="'tip'+item.sectionStauts">{{ getStatus('sys_section_stauts',item.sectionStauts)}}</div>
                        <div :data-obj="JSON.stringify(item)" v-else :class="'tip'+item.sectionStauts">{{ getStatus('sys_section_stauts_tenders',item.sectionStauts)}}</div>
                        <div :data-obj="JSON.stringify(item)"  style="margin: 0 20px;width: 160px" class="single-line">{{item.organization}}</div>
                        <div :data-obj="JSON.stringify(item)" style="width: 160px;color: #999999;">{{ item.createTime }}</div>
                    </div>
                </vueSeamlessScroll>
            </div>
            <img :src="require('../assets/home/advertisement'+locale+'.png') ">
            <div id="business">
                <div class="TitleBox">
                    <div>
                        <img style="vertical-align: sub;" src="@/assets/home/titleTip.png">
                        <span style="font-size: 18px;line-height: 25px;font-weight: 600;margin: 0 5px;">{{$t('view.招标项目')}}</span>
                        <!-- <span style="font-size: 14px;color: #999999;line-height: 20px;">Bidding project</span> -->
                    </div>
                    <div class="more" @click="more(0)">
                        {{$t('view.更多')}}
                        <img style="vertical-align: baseline;width: 12px;height: 13px;" src="@/assets/home/more.png">
                    </div>
                </div>
                <div class="box">
                    <div v-for="item in inviteList" :key="item.id" class="BoxItem BoxItemBJ boxHover" @click="TenderAnnouncement('TenderAnnouncement',item.sectionId)">
                        <div class="title">
                            <img src="@/assets/home/projectIcon.png">
                            <div style="max-width: 400px; margin-right: 12px;" class="single-line ">{{ item.sectionName }}</div>
                            <span :class="'projectType'+item.projectType">{{getStatus('sys_section_type',item.projectType)}}</span>
                        </div>
                        <div class="line" style="margin-top: 10px;">{{$t('view.招标单位：')}}{{ item.organization }}</div>
                        <!-- <div class="line">{{$t('view.预计金额：')}}{{ item.projectPrice }}</div> -->
                        <div class="stauts" :style="{background:item.sectionStauts!=7?'B80008':'#939393' }">{{ getStatus('sys_section_stauts',item.sectionStauts)  }}</div>
                    </div>
                </div>
                <div class="TitleBox">
                    <div>
                        <img style="vertical-align: sub;" src="@/assets/home/titleTip.png">
                        <span style="font-size: 18px;line-height: 25px;font-weight: 600;margin: 0 5px;">{{$t('view.询价项目')}}</span>
                        <!-- <span style="font-size: 14px;color: #999999;line-height: 20px;">Inquiry project </span> -->
                    </div>
                    <div class="more" @click="more(1)">
                        {{$t('view.更多')}}
                        <img style="vertical-align: baseline;width: 12px;height: 13px;" src="@/assets/home/more.png">
                    </div>
                </div>
                <div class="box">
                    <div v-for="item in inquiryList" :key="item.id" class="BoxItem BoxItemBJ1 boxHover" style="height: 100px;" @click="TenderAnnouncement('InquiryAnnouncement',item.sectionId)">
                        <div class="title">
                            <img src="@/assets/home/inquiry.png">
                            <div style="max-width: 400px; margin-right: 12px;" class="single-line ">{{ item.sectionName }}</div>
                            <span :class="'projectType'+item.projectType">{{getStatus('sys_section_type',item.projectType)}}</span>
                        </div>
                        <div class="line" style="margin-top: 10px;">{{$t('view.招标单位：')}}{{ item.organization }}</div>
                        <div class="stauts" style="background: #17257B;">{{ getStatus('sys_section_stauts',item.sectionStauts)  }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div style=" text-decoration: none;padding:20px 0 10px 0; display: flex; align-items: center;justify-content: center;">
            <img src="../assets/11.png" style="width: 20px;height: 20px;margin-right: 5px;">
            <a target="_blank" href="https://beian.miit.gov.cn/" style="color: #999;font-size: 12px;">鲁ICP备2022027079号-9</a>
        </div>
        <div style=" text-decoration: none;padding:0 0 10px 0; display: flex; align-items: center;justify-content: center;">
            <img src="../assets/11.png" style="width: 20px;height: 20px;margin-right: 5px;">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37068102000832" rel="noreferrer" style="color: #999;font-size: 12px;" target="_blank">鲁公网安备37068102000832号</a>
        </div>
    </div>
  </template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import {getDicts,homeListPage} from '@/api/index'
export default {
    components: { vueSeamlessScroll },
    data(){
        return{
            listData:[],
            scrollOptions:{
                step: 0.4, // 数字越大，滚动越慢
                limitMoveNum: 2, // 开始无限滚动前的滚动次数
                hoverStop: true, // 是否启用鼠标悬停停止滚动
                direction: 1, // 滚动方向，1 代表向下，0 代表向上
                openWatch: true, // 是否开启数据实时监控
                singleHeight: 0, // 单步滚动的高度(单位：px)
                singleWidth: 0, // 单步滚动的宽度(单位：px)
                waitTime: 1000, // 单步滚动的等待时间(单位：ms)
                autoPlay:false
            },
            announcementPageSize: 20,   // 每页拉取条数（分批异步，避免一次性渲染卡死）
            announcementMax: 200,       // 最多渲染条数上限（防数据量极大时 DOM 过多卡顿，可按需调大/移除）
            announcementTotal: 0,       // 后台真实数据总量
            announcementPage: 1,        // 当前已加载页码
            announcementLoading: false,// 拉取锁，防止并发重复请求
            announcementTimer: null,   // 滚动剩余量巡检定时器句柄
            announcementBuffer: 20,    // 滚动剩余不足该条数时，触发拉取下一页
            inquiryList:[],
            inviteList:[],
            locale: localStorage.getItem('locale')||'zh',
            sys_section_stauts:[],//项目状态
            sys_section_stauts_tenders:[],//招标的项目状态
            sys_section_type:[],//项目类型
        }
    },
    created(){
        this.getDicts('sys_section_type')
        this.getDicts('sys_section_stauts_tenders')
        this.getDicts('sys_section_stauts')
        // 招标列表
        this.homeListPage(0,8,'inviteList','signUpIng','7,8,2')
        // 询价列表
        this.homeListPage(1,8,'inquiryList','','1,2')
        // 顶部列表：按后台真实数据量异步分页滚动
        this.loadAnnouncements()


    },
    beforeDestroy(){
        this.stopPrefetchWatch()
    },
    methods:{
        // 滚动区域点击
        clickup(e) {
            if(!e.target.dataset.obj)
            return
            let item =JSON.parse(e.target.dataset.obj)
            let routeUrl= this.$router.resolve({
               path:item.biddingType==0?'TenderAnnouncement':'InquiryAnnouncement',
                 query:{
                    id:item.sectionId
                }
            })
            window.open(routeUrl.href, '_blank');
        },
        // 招标详情
        TenderAnnouncement(url,id){

            let routeUrl= this.$router.resolve({
                path: url,
                query: {id:id}
            })
            window.open(routeUrl.href, '_blank');
        },
        // 顶部公告：按后台真实数据量滚动，滚动驱动异步分页拉取，防卡死
        loadAnnouncements(){
            this.listData = []
            this.announcementPage = 1
            this.announcementTotal = 0
            this.scrollOptions.autoPlay = false
            this.fetchAnnouncementPage()
            // 启动“滚动剩余量”巡检：滚动到还剩不足 announcementBuffer 条时再拉下一页
            this.startPrefetchWatch()
        },
        startPrefetchWatch(){
            this.stopPrefetchWatch()
            this.announcementTimer = setInterval(()=>this.prefetchCheck(), 400)
        },
        stopPrefetchWatch(){
            if(this.announcementTimer){
                clearInterval(this.announcementTimer)
                this.announcementTimer = null
            }
        },
        // 依据 vue-seamless-scroll 内部实时位移计算“当前滚动还剩多少条可见”
        prefetchCheck(){
            const scroller = this.$refs.scroller
            // 未渲染完成或尚未开始滚动，跳过
            if(!scroller || !scroller.realBoxHeight) return
            // 动态测量单行高度（.listHover 高度），避免样式调整后写死数值
            const firstRow = scroller.$el.querySelector('.listHover')
            const rowH = firstRow ? firstRow.offsetHeight : 35
            const scrolledRows = Math.abs(scroller.yPos) / rowH   // 当前这一轮已滚过的行数
            const remaining = this.listData.length - scrolledRows // 本轮还剩多少条没滚到
            // 剩得不多了，且后台 total 还有、未触顶上限、且当前没有请求在飞 → 拉下一页
            if(remaining < this.announcementBuffer
                && this.listData.length < this.announcementTotal
                && this.listData.length < this.announcementMax
                && !this.announcementLoading){
                this.announcementPage += 1
                this.fetchAnnouncementPage()
            }
            // 已拉完所有数据，停止巡检
            if(this.listData.length >= this.announcementTotal){
                this.stopPrefetchWatch()
            }
        },
        fetchAnnouncementPage(){
            if(this.announcementLoading) return
            this.announcementLoading = true
            homeListPage({
                pageSize: this.announcementPageSize,
                pageNum: this.announcementPage,
                biddingType: '',
                projectType: '',
                searchValue: '',
                queryType: '',
                sectionStautsList: '1,7,8,9'
                // sectionStautsList: '1,7,8,9,2'
            }).then(res=>{
                const rows = (res.rows||[]).map(item=>{
                    item.sectionName = this.locale=='en'?item.sectionNameEn:this.locale=='lo'?item.sectionNameLo:item.sectionName
                    return item
                })
                // 累加渲染，而非一次性渲染全部，降低主线程压力
                this.listData = this.listData.concat(rows)
                this.announcementTotal = res.total || 0
                // 数据量超过可视行数才自动滚动，做到“有多少数据滚动多少”
                if(this.listData.length > this.scrollOptions.limitMoveNum){
                    this.scrollOptions.autoPlay = true
                }
            }).finally(()=>{
                this.announcementLoading = false
            })
        },
        //数据列表
        homeListPage(biddingType,pageSize,list,signUpIng,sectionStautsList ){
            // biddingType: 0招标 1询价
            homeListPage({
                pageSize:pageSize,
                pageNum:1,
                biddingType:biddingType,
                projectType:'',
                searchValue:'',
                queryType:signUpIng,
                sectionStautsList:sectionStautsList
            }).then(res=>{
                res.rows.map(item=>{
                    item.sectionName=this.locale=='en'?item.sectionNameEn:this.locale=='lo'?item.sectionNameLo:item.sectionName
                })
                this[list]=res.rows
            })
        },
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        more(biddingType){
            this.$router.push({
                path: '/TenderProject',
                query: {biddingType: biddingType}
            })
        }
    }
};
</script>
<style lang="scss" scoped>
    .topList{
        background: #fff;
        padding: 20px 0;
        width: 1200px;
    }
    .TitleBox{
        margin: 20px 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: solid 1px #D5D5D5;
    }

    .more{
        color:$mainBody-color;
        font-size: 14px;
        cursor: pointer;
    }
    .box{
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;
    }
    .BoxItem{
        position: relative;
        width: 550px;
        height: 110px;
        padding: 20px;
        margin-bottom: 20px;
        line-height: 25px;
        margin-right: 20px;
        cursor: pointer;
    }
    .BoxItem:nth-child(2n){
        margin-right: 0px;
    }
    .BoxItemBJ{
        background-image: url('../assets/home/BoxItemBJ.png');
        background-size: cover;
    }
    .BoxItemBJ1{
        background-image: url('../assets/home/BoxItemBJ1.png');
        background-size: cover;
    }
    .title{
        font-size: 18px;
        font-weight: 600;
        line-height: 25px;
        display: flex;
        align-items: center;
    }
    .line{
        color: #9C9C9C;
        line-height: 30px;
    }
    .stauts{
        position: absolute;
        width: 100px;
        height: 42px;
        line-height: 42px;
        background: $mainBody-color;
        color: #fff;
        text-align: center;
        bottom: 20px;
        right: 20px;
        font-size: 14px;
    }
    .projectType1{
         padding: 5px 15px;
        font-size: 16px;
        border-radius: 2px;
        background: #fff;
        font-weight: 400;
        color: #409eff;
    }
    .projectType2{
         padding: 5px 15px;
        font-size: 16px;
        border-radius: 2px;
        background: #fff;
        font-weight: 400;
        color: #67c23a;
    }
    .projectType3{
         padding: 5px 15px;
        font-size: 16px;
        border-radius: 2px;
        background: #fff;
        font-weight: 400;
        color: #e6a23c;
    }
    .projectType0{
         padding: 5px 15px;
        font-size: 16px;
        border-radius: 2px;
        background: #fff;
        font-weight: 400;
        color: #f56c6c;
    }
    .listHover{
        display: flex;align-items: center; height:35px;cursor: pointer;
    }
    .listHover:hover{
        background: #FBF2F2;
    }
    .boxHover:hover{
        box-shadow: 0px 0px 10px 0px rgba(7, 123, 238, 0.2);
    }
</style>
